import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';

import { EstadosDeFacturasYNotasDianComponent } from './EstadosDeFacturasYNotasDian.component';


import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';





const routes = [
    {
        path     : 'EstadosDeFacturasYNotasDian',
        component: EstadosDeFacturasYNotasDianComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'EstadosDeFacturasYNotasDian',
          nombreFormulario : 'EstadosDeFacturasYNotasDian'
        } 
    }
];

@NgModule({
    declarations: [
        EstadosDeFacturasYNotasDianComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        EstadosDeFacturasYNotasDianComponent
    ]
})

export class EstadosDeFacturasYNotasDianModule
{
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/EstadosDeFacturasYNotasDian/EstadosDeFacturasYNotasDian.module.ts